// extracted by mini-css-extract-plugin
export var emptyState = "_6a-d";
export var statCard = "_6a-c";
export var table = "_6a-0";
export var tableCell = "_6a-4";
export var tableCellClickable = "_6a-5 _6a-4";
export var tableCellDefault = "_6a-6 _6a-4";
export var tableCellEmpty = "_6a-8";
export var tableCellWithValue = "_6a-7";
export var tableContainer = "_6a-e";
export var tableHeaderWeight = "_6a-1";
export var tableHeaderZone = "_6a-2";
export var tableRowHeader = "_6a-3";
export var viewModeButton = "_6a-9";
export var viewModeButtonActive = "_6a-a _6a-9";
export var viewModeButtonInactive = "_6a-b _6a-9";